import { action, createRequestTypes } from './base';

export const purchaseRequestActionTypes = {
  GET_PURCHASE_REQUESTS: createRequestTypes('GET_PURCHASE_REQUESTS'),
  GET_MULTIPLE_PURCHASE_REQUESTS: createRequestTypes('GET_MULTIPLE_PURCHASE_REQUESTS'),
  GET_PURCHASE_REQUEST_BY_ID: createRequestTypes('GET_PURCHASE_REQUEST_BY_ID'),
  CREATE_PURCHASE_REQUEST: createRequestTypes('CREATE_PURCHASE_REQUEST'),
  UPDATE_PURCHASE_REQUEST: createRequestTypes('UPDATE_PURCHASE_REQUEST'),
  DELETE_PURCHASE_REQUEST: createRequestTypes('DELETE_PURCHASE_REQUEST'),
  UPDATE_PURCHASE_REQUEST_STATUS: createRequestTypes('UPDATE_PURCHASE_REQUEST_STATUS'),
  GET_PURCHASE_REQUEST_SQN: createRequestTypes('GET_PURCHASE_REQUEST_SQN'),
  GET_DOWNLOAD_PURCHASE_REQUEST_DATA: createRequestTypes('GET_DOWNLOAD_PURCHASE_REQUEST_DATA'),
  UPDATE_PR_WORKFLOW_STEP: createRequestTypes('UPDATE_PR_WORKFLOW_STEP'),
};

/**
 * PurchaseRequestActions class
 *
 * @param purchaseRequests
 * @param createPurchaseRequestLoading
 * @param payload
 * @param callback
 * @param prId
 * @param deletePurchaseRequestLoading
 * @param updatePurchaseRequestStatusLoading
 * @param getPurchaseRequestByIdLoading
 * @param selectedPurchaseRequest
 * @param tenantId
 * @param prSequence
 * @param getPurchaseRequestsLoading
 */
class PurchaseRequestActions {
  downloadPRData = (payload, callback) => action(purchaseRequestActionTypes.GET_DOWNLOAD_PURCHASE_REQUEST_DATA.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param {*} getDownloadPRLoading
   * @return
   */
  getDownloadPRDataLoading = (getDownloadPRLoading) => action(purchaseRequestActionTypes.GET_DOWNLOAD_PURCHASE_REQUEST_DATA.LOADING, {
    getDownloadPRLoading,
  })

  /**
   *
   * @param {*} downloadPOData
   * @return
   */
  getDownloadPRDataSuccess = (downloadPRData) => action(purchaseRequestActionTypes.GET_DOWNLOAD_PURCHASE_REQUEST_DATA.SUCCESS, {
    downloadPRData,
  })

  /**
   * @param tenantId
   * @param status
   * @param fromDate
   * @param toDate
   * @param deliveryFromDate
   * @param deliveryToDate
   * @param page
   * @param limit
   * @param tenantRoleId
   * @param callback
   * @param searchKeyword
   * @param tenantDepartmentId
   * @param moId
   * @param prId
   * @param sourceDepartmentId
   * @param modId
   * @param departmentId
   * @return {{type: *}}
   */
  getPurchaseRequests = (tenantId, status, fromDate, toDate, deliveryFromDate, deliveryToDate, tenantRoleId, page, limit, callback, searchKeyword, tenantDepartmentId, moId, prId, sourceDepartmentId, departmentId, productSearch, label, mrpId, fulfillmentStatus, isListScreen) => action(purchaseRequestActionTypes.GET_PURCHASE_REQUESTS.REQUEST, {
    tenantId, status, fromDate, toDate, deliveryFromDate, deliveryToDate, tenantRoleId, page, limit, callback, searchKeyword, tenantDepartmentId, moId, prId, sourceDepartmentId, departmentId, productSearch, label, mrpId, fulfillmentStatus, isListScreen
  });

  /**
   *
   * @param getPurchaseRequestsLoading
   * @return {{type: *}}
   */
  getPurchaseRequestsLoading = (getPurchaseRequestsLoading) => action(purchaseRequestActionTypes.GET_PURCHASE_REQUESTS.LOADING, {
    getPurchaseRequestsLoading,
  })

  /**
   *
   * @param purchaseRequests
   * @return {{type: *}}
   */
  getPurchaseRequestsSuccess = (purchaseRequests) => action(purchaseRequestActionTypes.GET_PURCHASE_REQUESTS.SUCCESS, {
    purchaseRequests,
  })

  /**
   * @param prId
   * @param tenantId
   * @param callback
   * @return {{type: *}}
   */
  getPurchaseRequestById = (prId, tenantId, callback) => action(purchaseRequestActionTypes.GET_PURCHASE_REQUEST_BY_ID.REQUEST, {
    prId, tenantId, callback,
  })

  /**
   *
   * @param getPurchaseRequestByIdLoading
   * @return {{type: *}}
   */
  getPurchaseRequestByIdLoading = (getPurchaseRequestByIdLoading) => action(purchaseRequestActionTypes.GET_PURCHASE_REQUEST_BY_ID.LOADING, {
    getPurchaseRequestByIdLoading,
  })

  /**
   *
   * @param selectedPurchaseRequest
   * @return {{type: *}}
   */
  getPurchaseRequestByIdSuccess = (selectedPurchaseRequest) => action(purchaseRequestActionTypes.GET_PURCHASE_REQUEST_BY_ID.SUCCESS, {
    selectedPurchaseRequest,
  })

  /**
   *
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  createPurchaseRequest = (payload, callback) => action(purchaseRequestActionTypes.CREATE_PURCHASE_REQUEST.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param createPurchaseRequestLoading
   * @return {{type: *}}
   */
  createPurchaseRequestLoading = (createPurchaseRequestLoading) => action(purchaseRequestActionTypes.CREATE_PURCHASE_REQUEST.LOADING, {
    createPurchaseRequestLoading,
  })

  /**
   *
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  updatePurchaseRequest = (payload, callback) => action(purchaseRequestActionTypes.UPDATE_PURCHASE_REQUEST.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param updatePurchaseRequestLoading
   * @return {{type: *}}
   */
  updatePurchaseRequestLoading = (updatePurchaseRequestLoading) => action(purchaseRequestActionTypes.UPDATE_PURCHASE_REQUEST.LOADING, {
    updatePurchaseRequestLoading,
  })

  /**
   * @param prId
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  deletePurchaseRequest = (payload, callback) => action(purchaseRequestActionTypes.DELETE_PURCHASE_REQUEST.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param deletePurchaseRequestLoading
   * @return {{type: *}}
   */
  deletePurchaseRequestLoading = (deletePurchaseRequestLoading) => action(purchaseRequestActionTypes.DELETE_PURCHASE_REQUEST.LOADING, {
    deletePurchaseRequestLoading,
  })

  /**
   *
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  updatePurchaseRequestStatus = (payload, callback) => action(purchaseRequestActionTypes.UPDATE_PURCHASE_REQUEST_STATUS.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param updatePurchaseRequestStatusLoading
   * @return {{type: *}}
   */
  updatePurchaseRequestStatusLoading = (updatePurchaseRequestStatusLoading) => action(purchaseRequestActionTypes.UPDATE_PURCHASE_REQUEST_STATUS.LOADING, {
    updatePurchaseRequestStatusLoading,
  })

  /**
   *
   * @param tenantId
   * @return {{type: *}}
   */
  getPrSequence = (tenantId) => action(purchaseRequestActionTypes.GET_PURCHASE_REQUEST_SQN.REQUEST, {
    tenantId,
  })

  /**
   *
   * @param getPrSequenceLoading
   * @return {{type: *}}
   */
  getPrSequenceLoading = (getPrSequenceLoading) => action(purchaseRequestActionTypes.GET_PURCHASE_REQUEST_SQN.LOADING, {
    getPrSequenceLoading,
  })

  /**
   *
   * @param prSequence
   * @return {{type: *}}
   */
  getPrSequenceSuccess = (prSequence) => action(purchaseRequestActionTypes.GET_PURCHASE_REQUEST_SQN.SUCCESS, {
    prSequence,
  })

  /**
   *
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  updatePrWorkflowStep = (payload, callback) => action(purchaseRequestActionTypes.UPDATE_PR_WORKFLOW_STEP.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param updatePrWorkflowStepLoading
   * @return {{type: *}}
   */
  updatePrWorkflowStepLoading = (updatePrWorkflowStepLoading) => action(purchaseRequestActionTypes.UPDATE_PR_WORKFLOW_STEP.LOADING, {
    updatePrWorkflowStepLoading,
  })

  /**
   *
   * @param params
   * @param callback
   * @returns {{type: *}}
   */
  getMultiplePurchaseRequests = (params, callback) => action(purchaseRequestActionTypes.GET_MULTIPLE_PURCHASE_REQUESTS.REQUEST, {
    params, callback,
  })

  /**
   *
   * @param getMultiplePurchaseRequestsLoading
   * @returns {{type: *}}
   */
  getMultiplePurchaseRequestsLoading = (getMultiplePurchaseRequestsLoading) => action(purchaseRequestActionTypes.GET_MULTIPLE_PURCHASE_REQUESTS.LOADING, {
    getMultiplePurchaseRequestsLoading,
  })

  /**
   *
   * @param multiplePurchaseRequests
   * @returns {{type: *}}
   */
  getMultiplePurchaseRequestsSuccess = (multiplePurchaseRequests) => action(purchaseRequestActionTypes.GET_MULTIPLE_PURCHASE_REQUESTS.SUCCESS, {
    multiplePurchaseRequests,
  })
}

export default new PurchaseRequestActions();
